module.exports = __webpack_public_path__ + "Frame395-7f0235e3.webp";